module.exports = __webpack_public_path__ + "img/70.4df867d.jpg";